import * as React from "react";
import { useDelay } from "./useDelay.js";
import { useEventCallback } from "./useEventCallback.js";
export function useThrottle(callback, delay) {
  var lastCallbackTime = React.useRef(0);
  var delayCallback = useDelay();
  var executeCallback = useEventCallback(function () {
    lastCallbackTime.current = Date.now();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callback(args);
  });
  return React.useCallback(function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    delayCallback(function () {
      executeCallback(args);
    }, delay - (Date.now() - lastCallbackTime.current));
  }, [delay, executeCallback, delayCallback]);
}